import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/reports";

// users graph
export const userGraphApi = async (filter = "30d") => {
  return await axiosInstance(options).get(`${path}/users-graph`, {
    params: { filter }
  });
};

// match graph
export const matchGraphApi = async (filter = "30d") => {
  return await axiosInstance(options).get(`${path}/match-graph`, {
    params: { filter }
  });
};

